<template>
    <div class="d-flex align-items-stretch">
        <navigation></navigation>
        <div class="container-fluid main-content page-content">
            <preloader-placeholder :loading="loading" :type="'configuration'"></preloader-placeholder>
            <div v-if="loading === false">
                <div class="page-header">
                    <h3 class="page-title">{{$t('config-voip-connector')}}</h3>
                </div>
                <search-numbers v-if="phoneNumber == undefined"/>
                <active-voip v-if="phoneNumber !== undefined"/>
            </div>
            <template  v-if="loading === false">
               <SmsInfoPlus></SmsInfoPlus>
            </template>
        </div>
    </div>
</template>
<script>

// Internal components
import PreloaderPlaceholder from '@/core/components/PreloaderPlaceholder.vue';
import ActiveVoip           from '../voip/ActiveVoip.vue';
import SearchNumbers        from '../SearchNumbers.vue';
import SmsInfoPlus          from '../SmsInfoPlus.vue';

// Import external libraries
import {
    mapState, mapActions, mapGetters
} from 'vuex';

export default {
    components: {
        ActiveVoip,
        SearchNumbers,
        PreloaderPlaceholder,
        SmsInfoPlus
    },

    data () {
        return {
            loading:       true,
            nameConnector: 'twilio'
        };
    },

    computed: {
        // State with activated phone number
        ...mapState('core/number', [
            'phoneNumber'
        ]),

        // Getter for the selected number
        ...mapGetters('core/number', { numberGetter: 'smsPhoneNumber' })
    },
    mounted () {
        this.nameConnector = window.location.href.split('/')[5];
        this.listNumber().then(() => {
            this.loading = false;
            this.numberGetter;
        });
    },
    methods: {
        // Method get list of activated number
        ...mapActions('core/number', { listNumber: 'index' })
    }
};
</script>
